import { AxiosPromise } from 'axios';

export interface IRecommendProduct {
  brand: string;
  name: string;
  photo: string;
  price: string;
  url: string;
}

const returnEmptyAxiosResponse = <T,>(data: T): AxiosPromise<T> => Promise.resolve({
  data,
  status: 200,
  statusText: 'OK',
  headers: {},
  config: {}
});


export const getPostTrending = (): AxiosPromise<string[]> =>
    // Disabled |axios.get(`${_get(process.env, 'REACT_APP_MIDDLEWARE', '')}/trending`);
    returnEmptyAxiosResponse([]);

export const searchForRecommend = (tagString: string, limit: number = 2): AxiosPromise<IRecommendProduct[]> => (
    // Disabled |axios.get(`${_get(process.env, 'REACT_APP_MIDDLEWARE', '')}/recommend?q=${tagString}&limit=${limit}`)
    returnEmptyAxiosResponse([])
);
